export enum CustomEventTypes {
    ComponentInited = 'ComponentInited',
    SingleStockWindowExpandCollapseStart = 'SingleStockWindowExpandCollapseStart',
    SingleStockWindowExpandCollapseDone = 'SingleStockWindowExpandCollapseDone',
}